import DeleteMenuOption from "components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption"
import EditMenuOption from "components/TableMonitoring/Body/RowMenuListActions/EditMenuOption"
import TableHeaderStatic from "components/TableMonitoring/Header/Static/TableHeaderStatic"
import TableMonitoring from "components/TableMonitoring"
import { useSelector } from "react-redux"
import TableRowStatic from "components/TableMonitoring/Body/TableRowStatic"
import TableBodyRowCenters from "./TableBodyRowCenters"
import { Box } from "@mui/material"
import DrawerHeader from "components/DrawerHeader"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import { centersTexts, CommonTexts } from "locale/es"
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import Loader from "components/Loader/Loader"
import NoDataTableBody from "components/TableMonitoring/Body/NoDataTableBody"
import { Outlet } from "react-router-dom"
import { useFilterContext } from "context/FilterContext"
import { useFilter } from "hooks/useFilter"
import FilterTable from "components/TableMonitoring/Toolbar/Filter"

const tableHeaders = [
  { name: centersTexts.UUID, value: "uuid" },
  { name: centersTexts.NAME, value: "name" },
  { name: centersTexts.APP, value: "app" },
  { name: centersTexts.PACKAGE, value: "businessPackage" },
  { name: centersTexts.ORGANIZATION, value: "organization" },
  { name: centersTexts.ACTIVE, value: "status" },
];

function CentersManagement() {
  const { data, loading, error } = useSelector(({ centers }) => centers)

  const { selectedFilter, searchTerm } = useFilterContext();

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);


  if (loading) {
    return (
      <Loader message={centersTexts.LOADING} pt={32} />
    )
  }

  return (
    <>
      <Box pt={4} pb={12} px={3} width="100%">
        <DrawerHeader />
        <BreadCrumbs
          name={CommonTexts.CENTERS}
          icon={<AddBusinessIcon sx={{ mr: 0.5 }} fontSize="inherit" />}
          mb={2}
        />
        <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              canCreate
            />
          }
        >
           {!!data && (selectedFilter && !searchTerm ? data : filteredData).map((center) => (
            <TableRowStatic
              key={center.id}
              entity={center}
              loaded={!loading}
              actions={<>
                <EditMenuOption entity={center} />
                <DeleteMenuOption entityId={center.id} />
              </>}
            >
              <TableBodyRowCenters center={center} />
            </TableRowStatic>
          ))}
        </TableMonitoring>
        {!data &&
          <NoDataTableBody
            entity={data}
            noDataMessage={centersTexts.NO_DATA}
          />
        }
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={data}
            noDataMessage={centersTexts.NO_DATA_FILTERS}
          />
        )}
      </Box>
      <Outlet />
    </>
  )
}

export default CentersManagement